import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export function hasMoved(
  a: GeolocationCoordinates | null = null,
  b: GeolocationCoordinates | null = null,
): boolean {
  if (!a || !b) return false;
  //  The * 1000 + Math.round gives ~111m precision — two positions that round to the same 3dp value won't trigger the banner.
  return (
    Math.round(a.latitude * 1000) !== Math.round(b.latitude * 1000) ||
    Math.round(a.longitude * 1000) !== Math.round(b.longitude * 1000)
  );
}
